import React, { Component } from 'react';
import PropTypes from 'prop-types';
import MapPropTypes from '../../MapPropTypes';
import Select from 'react-select-plus';
import ReduxStore from '@mgc/map-client-shared/lib/ReduxStore';
import { mapSelectors } from '@mgc/map-client-shared/lib/ReduxTools';
import selectors from '../../../selectors';
import UserActions from '../../../actions/user';
import strings from '../../../strings';

class UserSpoofer extends Component {
    static propTypes = {
        fetchSummaries: PropTypes.func.isRequired,
        myself: MapPropTypes.UserProps,
        spoofEnabled: PropTypes.bool.isRequired,
        spoofInProgress: PropTypes.bool.isRequired,
        spoofUser: PropTypes.func.isRequired,
        spoofer: MapPropTypes.UserProps,
        summaries: PropTypes.arrayOf(PropTypes.object),
        summariesInTransit: PropTypes.bool,
    };

    static mapState = (state) =>
        mapSelectors(state, {
            myself: selectors.user.getMyself,
            spoofEnabled: selectors.user.getSpoofEnabled,
            spoofInProgress: selectors.user.getSpoofInProgress,
            spoofer: selectors.user.getSpoofer,
            summaries: selectors.user.getSortedSummaries,
            summariesInTransit: selectors.user.getSummariesInTransit,
        });

    static mapDispatch = (dispatch) => ({
        fetchSummaries: () => dispatch(UserActions.fetchSummaries()),
        spoofUser: (userId) => {
            dispatch(UserActions.spoofUser(userId));
        },
    });

    componentDidMount() {
        if (!this.props.summaries || this.props.summaries.length === 0) {
            this.props.fetchSummaries();
        }
    }

    _handleCheckboxClick(event) {
        if (event.target.checked) {
            return this.props.spoofUser(this.props.summaries[0].id);
        }
        return this.props.spoofUser(null);
    }

    render() {
        if (!this.props.summaries || !this.props.myself) {
            return null;
        }

        const { myself, spoofEnabled, spoofer, summaries } = this.props;
        const cardClass = spoofer
            ? 'text-inverse card-success'
            : 'bg-gray-lightest';
        const value = spoofer ? myself.id : '';
        const loading =
            this.props.summariesInTransit || this.props.spoofInProgress;

        return (
            <div className="p-l-sm p-r-sm m-t-md spoofer">
                <div>
                    <label>
                        <input
                            type="checkbox"
                            onChange={(e) => this._handleCheckboxClick(e)}
                            checked={spoofEnabled}
                        />
                        &nbsp;
                        {strings.enableUserSpoofing}
                    </label>
                    <div className={`card p-a ${cardClass}`}>
                        <Select
                            options={summaries.map(
                                ({ firstName, lastName, email, id }) => ({
                                    label: `${firstName} ${lastName} - ${email}`,
                                    value: id,
                                })
                            )}
                            value={value}
                            onChange={(opt) =>
                                opt ? this.props.spoofUser(opt.value) : null
                            }
                            pageSize={3}
                            clearable={false}
                            disabled={loading || !spoofEnabled}
                            isLoading={loading}
                            valueRenderer={
                                loading ? () => strings.spoofing : undefined
                            }
                            placeholder={loading ? strings.spoofing : undefined}
                        />
                        {spoofer ? (
                            <div className="row m-t-sm text-sm p-l">
                                {strings.loggedInAs}&nbsp;
                                <em>
                                    {spoofer.firstName} {spoofer.lastName}
                                </em>
                            </div>
                        ) : null}
                    </div>
                </div>
            </div>
        );
    }
}

export default ReduxStore.attach(UserSpoofer);



// WEBPACK FOOTER //
// ./app/components/Modals/AccountModal/UserSpoofer.jsx